module.exports = __webpack_public_path__ + "53b77eff1d28340466fd9b9732bc70f1.pdf";